import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared-services/services/alert.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'alert',
    templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {

    constructor(private alertService: AlertService) { }

    message: any;

    ngOnInit() {
        this.alertService.getMessage().subscribe(message => { this.message = message; });
    }
}
